import { Stack } from '@trmediaab/zebra';
import { useCallback } from 'react';

import LoggedInUserCard from '../../components/LoggedInUserCard';
import NewUserCard from '../../components/NewUserCard';
import TextButton from '../../components/TextButton';
import type { CheckoutState } from '../../state';
import useUser from '../../state/useUser';

interface UserInfoProps {
  onPrev: () => void;
  order: NonNullable<CheckoutState['order']>;
}

const UserInfo = ({ order, onPrev }: UserInfoProps) => {
  const { user, logout } = useUser();

  const onChangeUser = useCallback(() => {
    if (user != null) {
      logout();
    }
    onPrev();
  }, [logout, onPrev, user]);

  // Note: email is optional on orders but here we expect it to have been set
  return (
    <Stack between="3">
      {user != null ? (
        <LoggedInUserCard user={user} />
      ) : (
        <NewUserCard email={order.email as string} />
      )}
      <TextButton label="Byt konto" onClick={onChangeUser} />
    </Stack>
  );
};

export default UserInfo;
